<div class="modal">
  <div class="container model-container">
    <div class="modal-header">
      <h5 class="modal-heading"> How to download your iPhone LTE settings</h5>
      <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
        alt="Close Icon">
    </div>

    <div class="modal-body" [ngSwitch]="activeStep">
      <div class="modal-content">
        <div class="flex-phone-display" *ngSwitchCase="1">
          <div class="steps">
            <p class="text-content smaller">1. Click on the <b>Download File</b> button below. File will be downloaded
              to your iPhone device:</p>
          </div>
          <div>
            <img *ngIf="context.isIos17" class="step-image" src="assets/img/step1-ios17.svg">
            <img *ngIf="!context.isIos17" class="step-image" src="assets/img/step1-{{this.context.network.toUpperCase()}}.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="2">
          <div class="steps">
            <p class="text-content smaller">
              2. Go to your iPhone’s Settings and Click on <b>‘General’</b>.
            </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step2-{{this.context.network.toUpperCase()}}.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="3">
          <div class="steps">
            <p class="text-content smaller">
              3. From VPN & Device Management, go to <b>‘Profile’</b>.
            </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step3.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="4">
          <div class="steps">
            <p class="text-content smaller">
              4. Next, click on the FreeUP LTE Data Settings tab to configure your iPhone LTE settings.
            </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step4.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="5">
          <div class="steps">
            <p class="text-content smaller">
              5. Click on ‘Install’ to install the LTE iPhone configuration settings on your device.
            </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step5.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="6">
          <div class="steps">
            <p class="text-content smaller">
              6. You will be asked for your device password.
            </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step6.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="7">
          <div class="steps">
            <p class="text-content smaller">
              7. Click <b>‘Install’</b> on the top right.
            </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step7.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="8">
          <div class="steps">
            <p class="text-content smaller">
              8. Click <b>‘Install’</b> again to confirm.
            </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step8.svg">
          </div>
        </div>

        <div class="flex-phone-display" *ngSwitchCase="9">
          <div class="steps">
            <p class="text-content smaller">
              9. You’re done! The iPhone LTE Data Settings have been successfully downloaded to your device.
            </p>
            <p class="sub-text caption">Make sure to power off your Device and restart after installation. </p>
          </div>
          <div>
            <img class="step-image" src="assets/img/step9.svg">
          </div>
        </div>

        <div class="modal-actions">
          <button class="button secondary" (click)="back()" *ngIf="this.activeStep > 1">Back</button>
          <button class="button primary" (click)="next()" *ngIf="activeStep < 9">Next</button>
          <button class="button primary" (click)="closeDialog()" *ngIf="activeStep === 9">Done</button>
        </div>
      </div>
    </div>
  </div>
</div>
